<template>
    <v-lazy class="mc-nc-drawing" :data-article="article" :min-height="48" @input="activate">
        <button v-if="drawing" type="button" class="mc-nc-drawing-button" :aria-label="`Apri disegno ${article}`" :title="`Apri disegno ${article}`" :disabled="opening" :aria-busy="String(opening)" @click.stop="openDrawing">
            <bt-disegno :key="article" :articolo="article" :disegno="drawing.disegno" :minio="drawing.minio" :multipagina="drawing.multipagina === 2" :width="192" :pdf-show="false" :auto-generate="false" s3-first class="mc-nc-drawing-image" />
        </button>
        <div v-else class="mc-nc-drawing-state" @click.stop>
            <v-progress-circular v-if="loading" indeterminate :size="24" aria-label="Caricamento disegno" />
            <button v-else-if="error" type="button" :aria-label="`Riprova il disegno di ${article}`" @click.stop="load"><v-icon small>mdi-refresh</v-icon><span>Riprova disegno</span></button>
            <span v-else>Disegno non disponibile</span>
        </div>
    </v-lazy>
</template>
<script>
import { bus } from "@/main";
import BtDisegno from "@/components/include/BtDisegno.vue";

export default {
    name: "NcInterneDrawing",
    components: { BtDisegno },
    inject: { ncDrawingRequests: { default: null } },
    props: { article: { type: String, default: "" } },
    data: () => ({ drawing: null, loading: false, opening: false, error: false, active: false, sequence: 0 }),
    watch: {
        article() {
            this.sequence++;
            this.drawing = null;
            this.error = false;
            this.loading = false;
            this.opening = false;
            if (this.active) this.load();
        },
    },
    beforeDestroy() { this.sequence++; },
    methods: {
        activate(visible) { if (visible && !this.active) { this.active = true; this.load(); } },
        pdfUrl(drawing) {
            // File capabilities must use the backend that issued their token.
            const base = (this.$workUrl || "").replace(/\/$/, "");
            if (drawing.pdf && base) return `${base}/commesse/getfile/${encodeURIComponent(drawing.pdf)}/`;
            const match = typeof drawing.minio === "string" && drawing.minio.match(/\/commesse\/(?:showfile|getfile)\/([^/?#]+)\/?$/);
            return match && base ? `${base}/commesse/getfile/${match[1]}/` : drawing.minio;
        },
        async openDrawing() {
            if (!this.drawing || this.opening) return;
            const drawing = this.drawing, article = this.article, sequence = this.sequence;
            this.opening = true;
            try {
                let url = this.pdfUrl(drawing);
                if (!url) {
                    const response = await this.$work.post("/arts/disegno/", { art: article, disegno: drawing.disegno }, false);
                    url = this.pdfUrl({ minio: response?.data?.minio });
                }
                if (!url) throw new Error("PDF non disponibile");
                if (sequence === this.sequence) bus.$emit("show-pdf", { articolo: article, disegno: drawing.disegno, minio: url });
            } catch (error) {
                if (sequence === this.sequence) this.$toast.error("Impossibile aprire il disegno. Riprova.", { icon: "mdi-file-alert", timeout: 5000 });
            } finally {
                if (sequence === this.sequence) this.opening = false;
            }
        },
        async load() {
            const article = this.article, sequence = ++this.sequence;
            this.drawing = null;
            this.error = false;
            this.loading = Boolean(article);
            if (!article) return;
            try {
                const fetch = async () => {
                    const response = await this.$work.get(`/arts/${encodeURIComponent(article)}/`, { cached: true }, false, null, {
                        rejectSilentErrors: true, ignoreGlobalErrorStatuses: [403, 404, 500, 503],
                    });
                    if (!response || !response.data || typeof response.data !== "object") throw new Error("Disegno non disponibile");
                    const drawing = response.data.disegno;
                    if (typeof drawing?.disegno === "string" && drawing.disegno.trim()) return [drawing];
                    const filename = response.data.disegno_nome;
                    return typeof filename === "string" && filename.trim() ? [{ disegno: filename.trim() }] : [];
                };
                const drawings = this.ncDrawingRequests ? await this.ncDrawingRequests.load(article, fetch) : await fetch();
                if (sequence === this.sequence) this.drawing = drawings[0] || null;
            } catch (error) {
                if (sequence === this.sequence) this.error = error?.response?.status !== 404;
            } finally {
                if (sequence === this.sequence) this.loading = false;
            }
        },
    },
};
</script>
<style scoped>
.mc-nc-drawing { width:var(--space-8); min-width:var(--space-8); flex:0 0 var(--space-8); }
.mc-nc-drawing-button,.mc-nc-drawing-state { width:var(--space-8); height:var(--space-7); border:1px solid var(--border-control); border-radius:var(--radius-sm); overflow:hidden; display:flex; align-items:center; justify-content:center; }
.mc-nc-drawing-button { background:var(--paper); padding:var(--space-1); cursor:zoom-in; }
.mc-nc-drawing-button:focus-visible,.mc-nc-drawing-state button:focus-visible { outline:2px solid var(--focus); outline-offset:2px; }
.mc-nc-drawing-image { width:100%; min-height:62px; pointer-events:none; }
.mc-nc-drawing-image ::v-deep .v-image { height:62px; }
.mc-nc-drawing-state { background:var(--surface-2); color:var(--ink-2); font-size:var(--nc-label-size); text-align:center; }
.mc-nc-drawing-state span { display:block; }
.mc-nc-drawing-state button { min-height:var(--touch-target); padding:var(--space-1); }
</style>
